<ng-container *ngIf="!loaded">
  <div class="loader-wrapper centered">
    <div class="loader-container">
      <app-loader></app-loader>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="loaded">
  <div class="mt-3">
    <div class="row">
      <div class="col-12">
        <h1 class="mb-0">
          {{ "AGENT_LIST.TITLE" | translate }}
          <span class="font-italic">“{{ agency ? agency.name : ls.agency }}”</span>
        </h1>
      </div>
      <div class="col-12" *ngIf="isAddNewAgentAvailable">
        <button
          class="btn btn-primary rounded float-right"
          [title]="'AGENT_LIST.ADD_AGENT_TOOLTIP' | translate"
          (click)="openModal(addNewAgentModal)"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="mt-4" *ngIf="agents?.length">
      <div class="table-responsive">
        <table class="table table-default table-hover mb-0">
          <thead>
            <tr>
              <th scope="col">{{ "AGENT_LIST.TABLE.EMAIL" | translate }}</th>
              <th scope="col">{{ "AGENT_LIST.TABLE.AGENT_ID" | translate }}</th>
              <th scope="col">{{ "AGENT_LIST.TABLE.ROLE" | translate }}</th>
              <th scope="col">
                {{ "AGENT_LIST.TABLE.INVITATION_STATUS" | translate }}
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let agent of agents
                  | slice
                    : (page - 1) * pageSize
                    : (page - 1) * pageSize + pageSize;
                let idx = index
              "
              [class.inactive]="agent.status === 'inactive'"
            >
              <td>{{ agent.email }}</td>
              <td>
                <input
                  [(ngModel)]="agent.agent_id"
                  (ngModelChange)="onChange(idx)"
                  type="text"
                  [placeholder]="
                    'AGENT_LIST.TABLE.AGENT_ID_PLACEHOLDER' | translate
                  "
                  class="form-control w-50 m-auto"
                />
              </td>
              <td>
                <select
                  class="form-control"
                  [(ngModel)]="agent.role"
                  (ngModelChange)="onChange(idx)"
                >
                  <option value="{{ agent.role }}" hidden>
                    {{ agent.role | titlecase }}
                  </option>
                  <option
                    value="{{ role.toLowerCase() }}"
                    *ngFor="let role of agentsRoles"
                  >
                    {{ role }}
                  </option>
                </select>
              </td>
              <td>
                {{
                  agent.is_verified
                    ? ("AGENT_LIST.TABLE.STATUS_ACCEPTED" | translate)
                    : ("AGENT_LIST.TABLE.STATUS_INVITED" | translate)
                }}
              </td>
              <td>
                <div
                  class="d-flex align-items-center justify-content-end gap-12"
                >
                  <ng-container *ngIf="!agent.is_verified">
                    <button
                      type="button"
                      class="btn btn-sm btn-tonal-primary"
                      (click)="handleInvitation('revoke', agent)"
                    >
                      {{ "AGENT_LIST.BUTTONS.REVOKE" | translate }}
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn-tonal-primary"
                      (click)="handleInvitation('resend', agent)"
                    >
                      {{ "AGENT_LIST.BUTTONS.RESEND" | translate }}
                    </button>
                  </ng-container>

                  <ng-container *ngIf="agent.email !== ls.email">
                    <button
                      *ngIf="agent.is_verified"
                      type="button"
                      class="btn btn-sm btn-outline-primary m-auto"
                      (click)="revokeOtp(agent)"
                    >
                      {{ "AGENT_LIST.BUTTONS.RESET_OTP" | translate }}
                    </button>

                    <div
                      class="custom-control custom-switch cursor-pointer">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        [id]="'agent_status_' + agent.id"
                        [ngModel]="agent.status === 'active'"
                        (ngModelChange)="
                          onChange(idx); onStatusChange($event, agent)
                        "
                        [disabled]="!agent.is_verified"
                      />
                      <label
                        class="custom-control-label"
                        [for]="'agent_status_' + agent.id"
                      ></label>
                    </div>

                    <i
                      class="material-symbols-outlined remove-icon"
                      [title]="'AGENT_LIST.REMOVE_TOOLTIP' | translate"
                      (click)="onRemoveAgentClick(agent)"
                    >
                      delete
                    </i>
                  </ng-container>

                  <ng-container *ngIf="agentHasChanges[idx]">
                    <span
                      class="btn btn-tonal-primary"
                      (click)="saveChanges(agent, idx)"
                      >{{ "BUTTONS.SAVE" | translate }}</span
                    >
                    <span
                      class="btn btn-secondary"
                      (click)="cancelChanges(agent, idx)"
                      >{{ "BUTTONS.CANCEL" | translate }}</span
                    >
                  </ng-container>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-5" *ngIf="!agents?.length">
      <div class="col">
        {{ "AGENT_LIST.NO_AGENTS" | translate }}
      </div>
    </div>
  </div>

  <ngb-pagination
    *ngIf="agents?.length > pageSize"
    class="d-flex justify-content-end mt-4"
    [collectionSize]="agents.length"
    [(page)]="page"
    [pageSize]="pageSize"
    [maxSize]="7"
    [boundaryLinks]="true"
    (pageChange)="onPageChange()"
  ></ngb-pagination>
</ng-container>

<ng-template #addNewAgentModal let-c="close" let-d="dismiss">
  <div class="modal-card card">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="card-header-title">
            {{ "AGENT_LIST.NEW_AGENT_MODAL.TITLE" | translate }}
          </h3>
        </div>
        <div class="col-auto">
          <i
            data-dismiss="modal"
            aria-hidden="true"
            (click)="d('closed')"
            class="material-icons float-right close-icon"
          >
            close
          </i>
        </div>
      </div>
    </div>
    <div class="card-body row">
      <div class="form-group-sm col-md-4">
        <label class="font-weight-bold">{{
          "AGENT_LIST.NEW_AGENT_MODAL.ROLE.LABEL" | translate
        }}</label>
        <select class="form-control" [(ngModel)]="model.role">
          <option value="" hidden selected>
            {{ "AGENT_LIST.NEW_AGENT_MODAL.ROLE.PLACEHOLDER" | translate }}
          </option>
          <option
            value="{{ role.toLowerCase() }}"
            *ngFor="let role of agentsRoles"
          >
            {{ role }}
          </option>
        </select>
        <div class="errors" [hidden]="!errors.role">
          {{ errors.role | capitalizeFirstLetter }}
        </div>
      </div>
      <div class="form-group-sm col-lg-12">
        <label class="font-weight-bold">{{
          "AGENT_LIST.NEW_AGENT_MODAL.EMAIL.LABEL" | translate
        }}</label>
        <input
          [(ngModel)]="model.email"
          class="form-control"
          type="text"
          [placeholder]="
            'AGENT_LIST.NEW_AGENT_MODAL.EMAIL.PLACEHOLDER' | translate
          "
        />
        <div class="errors" [hidden]="!errors.email">
          {{ errors.email | capitalizeFirstLetter }}
        </div>
      </div>
      <div class="col-lg-12">
        <div
          *ngIf="errors.error?.summary"
          class="alert-danger p-3 mb-3 rounded"
        >
          {{ errors.error.summary }}
        </div>
        <error-alert-block [error]="agentsError"> </error-alert-block>
      </div>
    </div>
    <div class="card-footer text-right">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        (click)="d('closed')"
      >
        {{ "BUTTONS.CANCEL" | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!(model.email && model.role)"
        (click)="addAgent(c)"
      >
        {{ "BUTTONS.ADD" | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #removeAgentInfoModal let-c="close" let-d="dismiss">
  <div class="modal-header" ngbAutoFocus>
    <h3 class="card-title">
      {{ "AGENT_LIST.REMOVE_AGENT_MODAL.TITLE" | translate }}
    </h3>
  </div>
  <div class="modal-body">
    <h3
      class="font-weight-normal lh-24"
      [innerHTML]="
        'AGENT_LIST.REMOVE_AGENT_MODAL.CONFIRM_MESSAGE'
          | translate: { email: selectedAgent.email }
      "
    ></h3>
    <div class="custom-control custom-checkbox mt-5 mr-sm-2">
      <input
        type="checkbox"
        class="custom-control-input"
        id="customControlInline"
        (change)="ls.isRemoveAgentInfoModalSkipped = $event.target.checked"
      />
      <label class="custom-control-label fs-16" for="customControlInline">{{
        "AGENT_LIST.REMOVE_AGENT_MODAL.DO_NOT_SHOW_AGAIN" | translate
      }}</label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="d('closed')">
      {{ "BUTTONS.CANCEL" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="removeAgent(selectedAgent); c('ok')"
    >
      {{ "BUTTONS.REMOVE" | translate }}
    </button>
  </div>
</ng-template>
